// extracted by mini-css-extract-plugin
module.exports = {"right":"right___1liqG"};